// extracted by mini-css-extract-plugin
export default {"form":"classes_form__OwrwW","form-container":"classes_form-container__m2uSJ","button-container":"classes_button-container__G2LbZ"};